import React from "react";

export default function RozoQuantLogo({ width = 220, height = 60 }) {
  return (
    <picture>
      <source
        srcSet="/logo-dark.svg"
        media="(prefers-color-scheme: dark)"
      />

      <img
        src="/logo-light.svg"
        alt="EasyGreeks"
        width={width}
        height={height}
        style={{
          display: "block",
          objectFit: "contain",
        }}
      />
    </picture>
  );
}